
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-marijuana-doctors/[[...location]]",
      function () {
        return require("private-next-pages/medical-marijuana-doctors/[[...location]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-marijuana-doctors/[[...location]]"])
      });
    }
  